/**
 * Some customers are facing issues with their cart. I did a fix but their carts need to be recreated.
 */

function getCookie(key) {
    const name = key + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
        const cookie = cookieArray[i].trim();
        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return "";
}

function setCookie(key, value, daysToExpire = 14) {
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
    const expires = "expires=" + expirationDate.toUTCString();
    document.cookie = key + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
}

const recreationFlag = '_wasCartRecreated';

if (!getCookie(recreationFlag)) {
    // remove cart
    setCookie('cart', '');
    // set flag
    setCookie(recreationFlag, 'true');
}